import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConstants } from '../../shared/constants/api-constants';

@Injectable({
  providedIn: 'root'
})
export class MyChangeRequestsService {

  constructor(private httpClient: HttpClient) { }

  getMyChangeRequests() : Observable<any>{
    return this.httpClient.get(ApiConstants.MyChangeRequests + 'all');
  }
}
